import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import ProductDetail from '../views/ProductDetail'
import ProductComment from '../components/Common/ProductComment'
import ProductListing from '../views/ProductListing'
import MerchandiseIdProductListing from '../views/MerchandiseIdProductListing'
import SearchPage from '../views/SearchPage'
import RecordedShow from '../components/TvShopSection/RecordedShow'
import PreOrderDetails from '../components/PreOrderDetailSection/PreOrderDetails'
import ShippingDetails from '../components/OrderHistorySection/ShippingDetails'
import CancelOrder from '../components/OrderHistorySection/CancelOrder'
import TrackOrder from '../components/OrderHistorySection/TrackOrder'
import CategoryListing from '../components/ProductListSection/CategoryListing'
import CustSupport from '../views/CustSupport'
import Chat from '../components/Chat'
import Info from '../views/Info'
import AboutUs from '../components/InfoSection/AboutUs'
import ContactUs from '../components/InfoSection/ContactUs'
import DeliveryPolicy from '../components/InfoSection/DeliveryPolicy'
import DisclaimerPolicy from '../components/InfoSection/DisclaimerPolicy'
import PrivacyPolicy from '../components/InfoSection/PrivacyPolicy'
import ReturnRefundPolicy from '../components/InfoSection/ReturnRefundPolicy'
import TermsConditions from '../components/InfoSection/TermsConditions'
import OrderSuccess from '../components/OrderHistorySection/OrderSuccess'
import PaymentWaiting from '../components/PreOrderDetailSection/PaymentWaiting'
import ProductReturn from '../components/OrderHistorySection/ProductReturn'
import GoliveLogin from '../components/GoliveLogin'
import GroupList from '../components/ProductDetailSection/ProductDetailTab/GroupList'
import NearPayOrderDetails from '../components/PreOrderDetailSection/NearPayOrderDetails'
import AddNewAddress from '../components/PreOrderDetailSection/AddNewAddress'
import GroupsProductListing from '../components/ShoppingGame/GroupsProductListing'
import CutThePriceProductListing from '../components/ShoppingGame/CutThePriceProductListing'
import ShoppingGame from '../views/ShoppingGame'
import SubCategoryListing from '../components/ProductListSection/SubCategoryListing'
import TvShop from '../views/TvShop'
import OrderHistory from '../views/OrderHistory'
import bus from "../main";

Vue.use(Router)
const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/detail/:saleReferenceID',
        name: 'ProductDetail',
        component: ProductDetail
    },
    {
        path: '/product-comment/:saleReferenceID',
        name: 'ProductComment',
        component: ProductComment
    },
    {
        path: '/share/:encodedId/:saleReferenceID',
        name: 'ProductDetail',
        component: ProductDetail
    },
    // {
    //     path: '/merchandise-product-by-id/:mid',
    //     name: 'ProductListing',
    //     component: ProductListing
    // },
    {
        path: '/merchandise-product-by-id/:mid',
        name: 'MerchandiseIdProductListing',
        component: MerchandiseIdProductListing
    },
    {
        path: '/product-by-category',
        name: 'ProductListing',
        component: ProductListing
    },
    {
        path: '/search',
        name: 'SearchPage',
        component: SearchPage
    },
    {
        path: '/video-detail/:saleReferenceID',
        name: 'RecordedShow',
        component: RecordedShow
    },
    {
        path: '/preOrderDetails/:preOrderId',
        name: 'PreOrderDetails',
        component: PreOrderDetails
    },
    {
        path: '/address-detail',
        name: 'AddNewAddress',
        component: AddNewAddress
    },
    {
        path: '/shippingDetails/:orderId',
        name: 'ShippingDetails',
        component: ShippingDetails
    },
    {
        path: '/cancel-order/:orderId',
        name: 'CancelOrder',
        component: CancelOrder
    },
    {
        path: '/track-order/:orderId',
        name: 'TrackOrder',
        component: TrackOrder
    },
    {
        path: '/category-listing',
        name: 'CategoryListing',
        component: CategoryListing
    },
    {
        path: '/cust-support',
        name: 'CustSupport',
        component: CustSupport
    },
    {
        path: '/BuyOnChat/:productId/:preOrderId',
        name: 'Chat',
        component: Chat
    },
    {
        path: '/info',
        name: 'Info',
        component: Info
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: AboutUs
    },

    {
        path: '/contact-us',
        name: 'ContactUs',
        component: ContactUs
    },

    {
        path: '/delivery-policy',
        name: 'DeliveryPolicy',
        component: DeliveryPolicy
    },
    {
        path: '/disclaimer-policy',
        name: 'DisclaimerPolicy',
        component: DisclaimerPolicy
    },
    {
        path: '/privacy-policy',
        name: "PrivacyPolicy",
        component: PrivacyPolicy
    },
    {
        path: '/return-refund-Policy',
        name: "ReturnRefundPolicy",
        component: ReturnRefundPolicy
    },
    {
        path: '/terms-conditions',
        name: "TermsConditions",
        component: TermsConditions

    },
    {
        path: '/orderDetails/:orderId',
        name: 'OrderSuccess',
        component: OrderSuccess
    },
    {
        path: '/paymentWaiting/:orderId',
        name: "PaymentWaiting",
        component: PaymentWaiting
    },
    {
        path: '/ProductReturn/:orderId',
        name: "ProductReturn",
        component: ProductReturn
    },
    {
        path: '/login-via-key/:urlToRedirect/:xAuthId',
        name: "GoliveLogin",
        component: GoliveLogin
    },
    {
        path: '/group-list/',
        name: "GroupList",
        component: GroupList
    },

    {
        path: '/nearpay-orderdetails/:orderId',
        name: "NearPayOrderDetails",
        component: NearPayOrderDetails
    },
    {
        path: '/groups-product-listing',
        name: "GroupsProductListing",
        component: GroupsProductListing
    },
    {
        path: '/cutprice-product-listing',
        name: "CutThePriceProductListing",
        component: CutThePriceProductListing
    },
    {
        path: '/shopping-game',
        name: "ShoppingGame",
        component: ShoppingGame
    },
    {
        path: '/subcategory-listing/:subcategoryid',
        name: "SubCategoryListing",
        component: SubCategoryListing
    },
    {
        path: '/live-show',
        name: "TvShop",
        component: TvShop
    },
    {
        path: '/order-history',
        name: "OrderHistory",
        component: OrderHistory
    },

    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise(resolve => {
        setTimeout(() => {
            if (savedPosition) {
                resolve(savedPosition);
              } else {
                resolve({ x: 0, y: 0 });
              }
          }, 1000);
        });
    }
})

router.beforeEach((to, from, next) => {
    if (Vue.cookie.get('version-code') > 57) {
        try {
            JSBridgePlugin.showBottomTabs(false)
        } catch (err) {
            console.log(err)
        }
    }

    next()
})
export default router;